import React, { useState } from "react";
import { enUS } from "date-fns/locale";
import { Dropdown, Button, Modal } from "react-bootstrap";
import { DateRangePicker } from "react-date-range";
import { useDispatch } from "react-redux";
import { showDialog, showErrorDialog } from "./dialog";
import moment from "moment";
import { useForceUpdate } from "./util";
import useIsMounted from "./useIsMounted";
import {
  setEndDateDashboard,
  setStartDateDashboard,
} from "../pages/company/companySlice";
import "./InputDateRange.css"; // Import custom CSS

export const InputDateRangeForm = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
}) => {
  const forceUpdate = useForceUpdate();
  const [selectedRange, setSelectedRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const isMountedRef = useIsMounted();

  const handleSelect = (ranges) => {
    const today = new Date();
    const startDate = new Date(ranges.selection.startDate);
    const endDate = new Date(ranges.selection.endDate);

    // Hanya ambil bagian tahun, bulan, dan tanggal untuk perbandingan
    const todayDateOnly = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    const startDateOnly = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate()
    );
    const endDateOnly = new Date(
      endDate.getFullYear(),
      endDate.getMonth(),
      endDate.getDate()
    );

    if (startDateOnly < todayDateOnly || endDateOnly < todayDateOnly) {
      showDialog("Backdating is not allowed. Please select a valid date range.");
    } else {
      setSelectedRange([ranges.selection]);
    }
  };

  const handleApply = async (e) => {
    e.stopPropagation();
    const newStartDate = moment(selectedRange[0].startDate).format(
      "YYYY-MM-DD"
    );
    const newEndDate = moment(selectedRange[0].endDate).format("YYYY-MM-DD");

    setStartDate(newStartDate);
    setEndDate(newEndDate);

    setIsDropdownOpen(false);
  };

  const handleClear = async (e) => {
    e.stopPropagation();
    setStartDate("");
    setEndDate("");
    forceUpdate();

    setIsDropdownOpen(false);
  };

  return (
    <>
      <Dropdown
        show={isDropdownOpen}
        onToggle={(isOpen) => setIsDropdownOpen(isOpen)}
        className="w-100"
      >
        <Dropdown.Toggle variant="secondary" id="dropdown-basic" block="true">
          {startDate === endDate ? (
            <span
              className="text-dark font-weight-bold"
              id="kt_dashboard_daterangepicker_date"
            >
              {startDate === ""
                ? "DD/MM/YYYY"
                : moment(startDate).format("DD/MM/YYYY")}
            </span>
          ) : (
            <span
              className="text-dark  font-weight-bold"
              id="kt_dashboard_daterangepicker_date"
            >
              {moment(startDate).format("DD/MM/YYYY")} -{" "}
              {moment(endDate).format("DD/MM/YYYY")}
            </span>
          )}
        </Dropdown.Toggle>
      </Dropdown>

      <Modal
        show={isDropdownOpen}
        onHide={() => setIsDropdownOpen(false)}
        centered
        className="modal-fullscreen"
      >
        <Modal.Body>
          <div className="d-flex flex-column">
            <DateRangePicker
              ranges={selectedRange}
              onChange={handleSelect}
              locale={enUS} // Pass the locale to the DateRangePicker component
              className="w-100"
            />
            <div className="d-flex justify-content-between mt-3">
              <Button
                className="mr-3 w-100"
                onClick={(e) => {
                  handleClear(e);
                }}
                variant="secondary"
              >
                Clear
              </Button>
              <Button
                className="mr-3 w-100"
                onClick={(e) => {
                  handleApply(e);
                }}
              >
                Apply
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
